import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/back_arrow.png")